export interface ProductListItem {
  id: string;
  name?: string;
  itemNumber?: string;
  code?: string;
  chineseColor?: string;
}

export interface ProductListQueryParams {
  currentPage: number;
  size: number;
  itemNumber?: string;
  code?: string;
  name?: string;
}

interface QueryPageResponse {
  data?: {
    ariesPlatformItemTplQuery?: {
      queryPage?: {
        content?: ProductListItem[];
        totalElements?: number | string;
      };
    };
  };
  errors?: Array<{ message?: string }>;
}

function buildGraphqlQuery(currentPage: number, size: number, rsql: string, queryData: string) {
  return `{
  ariesPlatformItemTplQuery {
    queryPage(
      page: {currentPage: ${currentPage}, size: ${size}}
      queryWrapper: {rsql: ${JSON.stringify(rsql)}, queryData: ${JSON.stringify(queryData)}}
    ) {
      content {
        id
        name
        itemNumber
        code
        chineseColor
      }
      totalElements
    }
  }
}`;
}

function encodeBase64(value: string) {
  return window.btoa(unescape(encodeURIComponent(value)));
}

function escapeRsqlLikeValue(value: string) {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)');
}

function escapeRsqlEqValue(value: string) {
  return value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

function buildQueryWrapper(params: ProductListQueryParams) {
  const itemNumber = (params.itemNumber ?? '').trim();
  const code = (params.code ?? '').trim();
  const keyword = (params.name ?? '').trim();

  const conditions: string[] = ['(1==1)'];
  if (itemNumber) {
    conditions.push(`(itemNumber=='${escapeRsqlEqValue(itemNumber)}')`);
  }
  if (keyword) {
    conditions.push(`(name=like='${escapeRsqlLikeValue(keyword)}')`);
  }
  if (code) {
    conditions.push(`(code=='${escapeRsqlEqValue(code)}')`);
  }

  const queryData = {
    code: code || null,
    itemNumber: itemNumber || null,
    name: keyword || null,
    batchOutCode: null as string | null,
    barCode: null as string | null,
    categoryCode: null as string | null,
  };
  const rsqlExpression = `(1==1) and (${conditions.join(' and ')})`;

  return {
    rsql: `base64:${encodeBase64(rsqlExpression)}`,
    queryData: JSON.stringify(queryData),
  };
}

export async function queryProductListPage(params: ProductListQueryParams) {
  const queryWrapper = buildQueryWrapper(params);
  const response = await fetch(`/pamirs/AriesCorePlatform`, {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      accept: '*/*',
      'content-type': 'application/json',
      module: 'AriesCorePlatform',
    },
    body: JSON.stringify({
      operationName: null,
      query: buildGraphqlQuery(params.currentPage, params.size, queryWrapper.rsql, queryWrapper.queryData),
    }),
  });

  if (!response.ok) {
    throw new Error(`接口请求失败: ${response.status}`);
  }

  const result: QueryPageResponse = await response.json();
  if (result.errors?.length) {
    throw new Error(result.errors[0]?.message || 'GraphQL 请求失败');
  }

  const pageData = result.data?.ariesPlatformItemTplQuery?.queryPage;
  return {
    content: pageData?.content ?? [],
    totalElements: Number(pageData?.totalElements ?? 0),
  };
}
